import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const dataChart = (labels, data) => {
    return {
        labels: labels,
        datasets: [
            {
                label: '',
                data: data,
                backgroundColor: [
                    'rgb(54, 185, 21)', 'yellow', 'red'
                ],
                borderColor: [
                    'rgb(54, 185, 21)', 'yellow', 'red'
                ],
                borderWidth: 1,
                datalabels: {
                    labels: {
                        name: {
                            align: 'bottom',
                            // font: { size: 16 },
                            // etiquetas con porcentajes menores al 10% no mostrar
                            formatter: function (value, ctx) {  
                                const num = parseFloat(ctx.chart.data.labels[ctx.dataIndex])                                
                                return isNaN(num) || num < 10 ? '' : ctx.chart.data.labels[ctx.dataIndex] + '%'                                
                            },

                        },
                        value: {
                            align: 'top',
                            // font: { size: 16 },
                            // valores con porcentajes menores al 10% canal alpha en 0
                            color: function (ctx) {
                                const num = parseFloat(ctx.chart.data.labels[ctx.dataIndex])                                
                                return isNaN(num) || num < 10 ? 'rgba(255, 255, 255, 0)' : 'black' 
                            },
                        }
                    }
                }

            },
        ],
    };
}

const optionsChart = (ratio) => {
    return {
        aspectRatio: ratio,
        // maintainAspectRatio: false,
        responsive: true,
        plugins: {
            datalabels: {
                color: '#000',
                // font: {
                //     weight: 'bold',
                // },
                offset: 0,
                padding: 0
            },
            tooltip: {
                enabled: false,
            },
            legend: {
                display: false
            },
        }

    }
}

export default function Chart({ data, ratio = 1 }) {
    // ratio = 1: large, 2: small

    return <Pie data={dataChart(data.labels, data.data)} options={optionsChart(ratio)} />;
}
